module.exports = __webpack_public_path__ + "img/1-38-1.c9e2fbb5.png";